import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.css']
})
export class ResetPasswordDialogComponent implements OnInit {

  @Input()
  showResetDialog;

  @Output() onHide = new EventEmitter<boolean>();
    hide(){
       this.onHide.emit(true);
    }

  constructor(private service: UserService, private toaster: ToastrService) { }

  email ="";

  reset(){
    if(this.email.length<5){
      this.toaster.error("Email informado inválido", "Restablecer contraseña");
      return;
    } 
    this.service.reset_password(this.email).subscribe(d=>{
      this.toaster.success("Te enviamos un email con los pasos para restablecer tu contraseña", "Restablecer contraseña");
      this.hide();
    }, er=>{
      this.toaster.error( er.error,"Error");
    });
  }

  ngOnInit() {
  }

}
